import { Vectorizer } from '@clientio/rappid'
import RappidContext from './rappid-context'

export default class AceLayer {
  constructor(private context: RappidContext) {}

  init(): void {
    // Container for all HTML views inside paper
    const htmlContainer = document.createElement('div')
    htmlContainer.setAttribute('id', 'htmlContainer')
    htmlContainer.style.pointerEvents = 'none'
    htmlContainer.style.position = 'absolute'
    this.context.paper.el.appendChild(htmlContainer)

    this.context.paper.on('scale translate', () => {
      // Update the transformation of all JointJS HTML Elements
      htmlContainer.style.transformOrigin = '0 0'
      htmlContainer.style.transform = Vectorizer.matrixToTransformString(
        this.context.paper.matrix(),
      )
    })
  }
}
